<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      退会
    </Header>
    <div class="mypage py-3">
      <div class="section px-3 pt-4 mt-2">
        <div class="bg-white border border-outline-color px-2 mt-1 round-4">
          <ul class="mt-3 text-size-14">
            <li class="list-indent">
              ・ポイントは退会後全て削除され、復元できません。
            </li>
            <li class="list-indent">
              ・ウォレットに残高がある場合は退会できません。
            </li>
            <li class="list-indent">
              ・退会と合わせて源泉徴収票が必要な方は、アプリよりダウンロード後の退会をお願いいたします。
            </li>
            <li class="list-indent">
              ・労働基準法に準拠するため、一部ユーザー情報は一定期間保存されます。
            </li>
          </ul>
        </div>
        <div class="py-3 text-center">
          <AppButton
            variant="primary"
            class="mt-2"
            size="sm"
            @click="goToLeavedQuestionnairePage()"
          >
            上記の内容に同意する
          </AppButton>
        </div>
      </div>

      <AppFooter />
      <BlockBack />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import { AccountService } from "@/app/services/v2/AccountService";
import Header from "@/components/organisms/common/Header.vue";
import AppFooter from "@/components/organisms/common/AppFooter.vue";
import BlockBack from "@/components/organisms/common/BlockBack.vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { sendAdjustEvent } from "@/plugins/adjust";
import { sendFirebaseCustomEvent } from "@/plugins/firebase";
import { authStore } from "@/store/auth";
import { routerPush } from "@/utils/routerPush";
import { showErrorModal } from "@/utils/showErrorModal";

@Component({
  components: {
    Header,
    AppButton,
    FeatherIcon,
    AppFooter,
    BlockBack
  }
})
export default class LeaveConfirmation extends Vue {
  async created() {
    await sendAdjustEvent("SHOW_LEAVE");
    sendFirebaseCustomEvent("show_leave", {
      username: authStore.user?.username || "unknown"
    });
  }

  async goToLeavedQuestionnairePage() {
    try {
      this.$loading.show();
      await AccountService.canLeave();
      routerPush(this, { name: "LeaveQuestionnaire" });
    } catch (e) {
      await showErrorModal(this, e as Error);
    } finally {
      this.$loading.hide();
    }
  }

  async onClickBack() {
    await routerPush(this, { name: "OtherAccountInfo" });
  }
}
</script>

<style lang="scss" scoped>
.mypage {
  position: relative;

  .section {
    // iPhone のノッチ対応
    padding-top: env(safe-area-inset-top, 0);
  }
}

.list-indent {
  padding: 0 0 1em 1em;
  text-indent: -1em;
}
</style>
